import React from 'react';
import curvyAarya2 from './assets/curvyAarya2.png';
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="bg=transparent">
      <div className="w-full h-[80px]">
        <div className="max-w-[1480px] m-auto w-full h-full flex justify-between items-center">
          <Link to="/" className='flex items-center'><img src={curvyAarya2} className='h-8 md:h-10 lg:h-[40px]'/></Link>
          <div className="flex items-center flex gap-2 md:gap-4">
            <Link to="/about" className="text-white hover:text-gray-300 text-base">About</Link>
            <Link to="/projects" className="text-white hover:text-gray-300 text-base">Projects</Link>
            <Link to="/adventures" className="text-white hover:text-gray-300 text-base">Adventures</Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;